export class WebhookConfiguration {
  public static minimumAllowedRetyCount: 1;
  public static maximumAllowedRetyCount: 3;
  public static maximumAllowedHooksPerApp: 10;
  public static maximumAllowedRequestsPerHook: 3;
  public static maximumAllowedHeadersPerRequest: 4;
}
